import { c as _c } from "react/compiler-runtime";
import './content-feed-progress-bar.scss';
import React from 'react';
export interface ContentFeedProgressBarProps {
  /** Current progress percentage (0–100) */
  percent: number;
  /** Accessible label describing the progress */
  ariaLabel: string;
}

/**
 * A horizontal progress bar representing funding progress.
 */
export const ContentFeedProgressBar: React.FC<ContentFeedProgressBarProps> = t0 => {
  const $ = _c(6);
  const {
    percent,
    ariaLabel
  } = t0;
  const t1 = `${percent}%`;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      width: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== ariaLabel || $[3] !== percent || $[4] !== t2) {
    t3 = <div className="ContentFeedProgressBar"><div className="ContentFeedProgressBar__fill" style={t2} role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} aria-label={ariaLabel} /></div>;
    $[2] = ariaLabel;
    $[3] = percent;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};